import { END_POINT } from '../end-point';
import { TPostUsersData, TResPostUsers } from '../../types/api';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

type PolicyResponse = {
  data: {
    terms: string;
    termsPolicyId: number;
    privacy: string;
    privacyPolicyId: number;
  };
};

type SecurityResponse = {
  data: {
    security: string;
    securityPolicyId: number;
  };
};
type TTermsResponse = {
  data: {
    dates: string[];
    content: string;
  };
};

const policyAPI = {
  // 약관동의 조회 API => 회원가입페이지에 사용됨
  async getPolicyAPI(): Promise<PolicyResponse> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.policyController.getPolicies(), {
        withCredentials: true

        // headers: {
        //   Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        // }
      });
      // console.log('getPolicyAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getPolicyAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },
  // 보안서약 조회 API => 내방신청에 사용됨
  async getSecurityAPI(): Promise<SecurityResponse> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.policyController.getSecurity(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getSecurityAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getSecurityAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },

  // 개인정보처리방침 저장 API
  async postPrivacyAPI(isNewVersion: boolean, privacyNewDate: string | null, privacy: string, language: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post(
        END_POINT.policyController.postPrivacy(),
        { isNewVersion: isNewVersion, versionDate: privacyNewDate, content: privacy, language: language },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
          }
        }
      );
      // console.log('개인정보처리방침 저장 성공: ', privacy, response);
      return response;
    } catch (error) {
      // console.log('개인정보처리방침 저장 전달된 데이터: ', privacy);
      // console.error('개인정보처리방침 저장 실패: ', error);
      console.error(error);
      throw error;
    }
  },
  // 이용약관 저장 API
  async postTermsAPI(terms: string, language: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post(
        END_POINT.policyController.postTerms(),
        { isNewVersion: false, content: terms, language: language },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
          }
        }
      );
      // console.log('이용약관 저장 성공: ', response);
      return response;
    } catch (error) {
      // console.error('이용약관 저장 실패: ', error);
      console.error(error);
      throw error;
    }
  },
  // 보안서약 저장 API
  async postSecurityAPI(security: string, language: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post(
        END_POINT.policyController.postSecurity(),
        { isNewVersion: false, content: security, language: language },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
          }
        }
      );
      // console.log('보안서약 저장 성공: ', response);
      return response;
    } catch (error) {
      // console.error('보안서약 저장 실패: ', error);
      console.error(error);
      throw error;
    }
  },
  // 모든 이용약관 불러오기 API => 이용약관 페이지에 사용됨
  async getTermsAPI(): Promise<TTermsResponse> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.policyController.getTerms(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getTermsAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getTermsAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },
  // 모든 개인정보처리방침 불러오기 API => 개인정보처리방침 페이지에 사용됨
  async getPrivacyAPI(date?: string): Promise<TTermsResponse> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.policyController.getPrivacy(date), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getPrivacyAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getPrivacyAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  }
};

export const { getPolicyAPI, getSecurityAPI, postPrivacyAPI, postTermsAPI, postSecurityAPI, getTermsAPI, getPrivacyAPI } = policyAPI;
